import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import { ArrowLeftOutlined, DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { useReactToPrint } from "react-to-print";

import JournalRecordFilters from "./components/JournalRecordFilters";
import JournalRecordTable from "./components/JournalRecordTable";
import ReportDom from "../../../components/common/ReportDom";
import { fetchJournalRecord } from "./journalRecordThunk";
import { useNavigate } from "react-router-dom";
import { exportJournalRecordCsv } from "./components/exportJournalRecordCsv";

const { Title } = Typography;

const JournalRecord = () => {
  const dispatch = useDispatch();
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters, list } = useSelector((state) => state.journalRecord);
  const navigate = useNavigate();

  const handleNavigateToReports = () => {
    navigate(-1);
  };

  useEffect(() => {
    dispatch(fetchJournalRecord({})); // initial load
  }, [dispatch]);

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Journal Record",
    removeAfterPrint: true,
  });

  const handleDownloadCsv = () => {
    exportJournalRecordCsv({
      list,
      filters,
      title:    "Journal Record Report",
      filename: "journal_record",
    });
  };

  const hasData = list.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={
          <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={handleNavigateToReports}
                style={{ marginRight: 8 }}
              />  
          <Title level={4} style={{ margin: 0 }}>Journal Record</Title>
          </div>
        }
          extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button
                type="primary"
                icon={<PrinterOutlined />}
                onClick={handlePrint}
              >
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <JournalRecordFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <JournalRecordTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Journal Record"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <JournalRecordTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default JournalRecord;
